interface IProps {
  children: React.ReactNode;
}

const MenuIconWrapper: React.FC<IProps> = ({ children }) => {
  return <div className="mr-2">{children}</div>;
};

export default MenuIconWrapper;
